import React, { Component } from "react";

export default class SitiosInteres extends Component {
  render() {
    return <div>SitiosInteres</div>;
  }
}
